import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'
import auth from '@feathersjs/authentication-client'

const create = (baseURL = process.env.REACT_APP_API) => {
  // Configuration
  const app = feathers()

  const socket = io(baseURL)

  app.configure(socketio(socket))

  app.configure(auth({ storageKey: 'auth' }))

  // Authentication
  const check = () => app.reAuthenticate()

  const login = (data) => app.authenticate({ ...data, ...{ strategy: 'local' } })

  const logout = () => app.logout()

  // Services
  const service = (name) => app.service(name)

  const register = (service, method) => {
    socket.emit('subscribe', {service, method})
  }
  const unregister = (service, method) => {
    socket.emit('unsubscribe', {service, method})
  }

  const find = (name, params) => app.service(name).find(params)
  const get = (name, id, params) => app.service(name).get(id, params)
  const create = (name, data, params) => app.service(name).create(data, params)
  const update = (name, id, data, params) => app.service(name).update(id, data, params)
  const patch = (name, id, data, params) => app.service(name).patch(id, data, params)
  const remove = (name, id, params) => app.service(name).remove(id, params)

  return {
    service,
    find,
    get,
    create,
    update,
    patch,
    remove,
    io: app.io,
    register,
    unregister,
    check,
    login,
    logout,
  }
}

export default {
  create,
}
